import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";
import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";
import { PROJECT_HEALTH_STATUS_VALUES } from "@/lib/constants/project-health";
import type { ProjectHealthStatus } from "@/lib/types/database/deals";

const PROJECT_HEALTH_LABELS: Record<ProjectHealthStatus, string> = {
  red: "Red - At Risk",
  yellow: "Yellow - Warning",
  green: "Green - Healthy",
};

/** Shared RAG options for all four project-health dimensions. */
const PROJECT_HEALTH_OPTIONS = PROJECT_HEALTH_STATUS_VALUES.map((value) => ({
  value,
  label: PROJECT_HEALTH_LABELS[value],
}));

export const projectHealthDealsFields = defineFieldConfigMap({
  /** On-time / schedule risk vs plan. */
  // FIELD: schedule_status
  schedule_status: {
    type: "select",
    label: "Schedule Health",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    filterType: "exact",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    groupable: true,
    options: PROJECT_HEALTH_OPTIONS,
    placeholder: "Select status",
    icon: "Clock",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "project_health",
  },
  /** Budget and margin trajectory vs expectations. */
  // FIELD: budget_status
  budget_status: {
    type: "select",
    label: "Budget/Margin Health",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    filterType: "exact",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    groupable: true,
    options: PROJECT_HEALTH_OPTIONS,
    placeholder: "Select status",
    icon: "DollarSign",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "project_health",
  },
  /** Scope creep / change control / fit to committed work. */
  // FIELD: scope_status
  scope_status: {
    type: "select",
    label: "Scope Control Health",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    filterType: "exact",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    groupable: true,
    options: PROJECT_HEALTH_OPTIONS,
    placeholder: "Select status",
    icon: "Target",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "project_health",
  },
  /** Stakeholder alignment and client expectation match. */
  // FIELD: alignment_status
  alignment_status: {
    type: "select",
    label: "Client Alignment Health",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    filterType: "exact",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    groupable: true,
    options: PROJECT_HEALTH_OPTIONS,
    placeholder: "Select status",
    icon: "Users",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "project_health",
  },
});
